import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OpportunityFormData } from '../../models/virtual-interview-model';

@Component({
  selector: 'app-opportunity-details',
  templateUrl: './opportunity-details.component.html',
  styleUrls: ['./opportunity-details.component.css'],
})
export class OpportunityDetailsComponent implements OnInit {
  @Output() next = new EventEmitter<OpportunityFormData>();
  @Output() previous = new EventEmitter<void>();
  @Input() initialData: OpportunityFormData | null = null;

  opportunityForm!: FormGroup;
  keywords: string[] = [];
  keywordInput: string = '';

  languages = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'العربية' },
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.opportunityForm = this.fb.group({
      jobTitle: ['', [Validators.required]],
      jobDescription: ['', [Validators.required]],
      language: ['en'],
    });

    if (this.initialData) {
      this.opportunityForm.patchValue({
        jobTitle: this.initialData.jobTitle,
        jobDescription: this.initialData.jobDescription,
        language: this.initialData.language || 'en',
      });
      this.keywords = [...this.initialData.keywords];
    }
  }

  get jobTitleInvalid(): boolean {
    const ctrl = this.opportunityForm.get('jobTitle');
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  get jobDescriptionInvalid(): boolean {
    const ctrl = this.opportunityForm.get('jobDescription');
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  addKeyword(): void {
    const trimmedKeyword = this.keywordInput.trim();
    if (trimmedKeyword && !this.keywords.includes(trimmedKeyword)) {
      this.keywords.push(trimmedKeyword);
      this.keywordInput = '';
    }
  }

  removeKeyword(index: number): void {
    this.keywords.splice(index, 1);
  }

  onKeywordKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.addKeyword();
    }
  }

  onNext(): void {
    if (this.opportunityForm.invalid) {
      this.opportunityForm.markAllAsTouched();
      return;
    }

    const { jobTitle, jobDescription, language } = this.opportunityForm.value;

    const formData: OpportunityFormData = {
      jobTitle: jobTitle.trim(),
      jobDescription: jobDescription.trim(),
      keywords: this.keywords,
      language,
    };

    this.next.emit(formData);
  }

  onPrevious(): void {
    this.previous.emit();
  }
}
